module.exports = __webpack_public_path__ + "static/img/manager_firma_isabel_von.a99040b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager_firma_isabel_von.png
// module id = JdRD
// module chunks = 1